import appStore from 'store';
import api from './api';
import {POSITION_TYPE, PLATFORM_TYPE, BANNER_TYPE} from './constants';
import LANGUAGE from 'common/languages';
import {PAGINATION} from "common/config";
import pagination from "components/pagination/index.vue";

const store = {
    namespaced: true,
    state: {
        query: {
            language: Number(Object.keys(LANGUAGE)[0]),
            platform: Number(Object.keys(PLATFORM_TYPE)[0]),
            type: Number(Object.keys(BANNER_TYPE)[0])
        },
        uploadData: {
            language: Number(Object.keys(LANGUAGE)[1]),
            platform: Number(Object.keys(PLATFORM_TYPE)[0]),
            type: Number(Object.keys(BANNER_TYPE)[0])
        },
        bannerList: [],
        noticeList: [],
        detailDialogVisible: false,
        noticeDetailDialogVisible: false,
        noticeCreateDialogVisible: false,
        localNoticeDetailDialogVisible: false,
        bannerDetail: {},
        noticeDetail: {
            id: 0,
            title: '',
            content: ''
        },
        noticeCreate: {
            title: '',
            content: ''
        },
        positionTypeList: Object.keys(POSITION_TYPE).map(item => {
            return {
                value: Number(item),
                label: POSITION_TYPE[item]
            };
        }),
        platformTypeList: Object.keys(PLATFORM_TYPE).map(item => {
            return {
                value: Number(item),
                label: PLATFORM_TYPE[item]
            };
        }),
        bannerTypeList: Object.keys(BANNER_TYPE).map(item => {
            return {
                value: Number(item),
                label: BANNER_TYPE[item]
            };
        }),
        languageList: Object.keys(LANGUAGE).map(item => {
            return {
                value: Number(item),
                label: LANGUAGE[item]
            };
        }),
        pagination: PAGINATION,
        totalCount: 0
    },
    getters: {
        bannerList: state =>
            state.bannerList
                .map(item => {
                    return {
                        ...item,
                        __positionType: POSITION_TYPE[item.sort],
                        __language: LANGUAGE[item.language],
                        __bannerType: BANNER_TYPE[item.type],
                        __platform: PLATFORM_TYPE[item.platform]
                    };
                })
                .sort((a, b) => a.sort - b.sort)
                .sort((a, b) => a.platform - b.platform),
        bannerDetail: state => state.bannerDetail,
        noticeList: state =>
            state.noticeList
                .map(item => {
                    return {
                        ...item,
                        __positionType: POSITION_TYPE[item.sort],
                        __language: LANGUAGE[item.language],
                        __bannerType: BANNER_TYPE[item.type],
                        __platform: PLATFORM_TYPE[item.platform]
                    };
                })
                .sort((a, b) => a.sort - b.sort)
                .sort((a, b) => a.platform - b.platform)
    },
    mutations: {
        setBannerList(state, payload) {
            state.bannerList = payload.slice();
        },
        setNoticeList(state, payload) {
            state.noticeList = payload.list.slice();
            state.totalCount = payload.totalCount;
        },
        toggleDetailDialogVisible(state, payload) {
            state.detailDialogVisible = payload;
        },
        toggleNoticeDetailDialogVisible(state, payload) {
            state.noticeDetailDialogVisible = payload;
        },
        toggleNoticeCreateDialogVisible(state, payload) {
            state.noticeCreateDialogVisible = payload;
        },
        setBannerDetail(state, payload) {
            state.bannerDetail = Object.assign({}, payload);
        },
        setNoticeDetail(state, payload) {
            state.noticeDetail = Object.assign({}, payload);
        },
        setNoticeCreate(state, payload) {
            state.noticeCreate = Object.assign({}, payload);
        },
        changeQuery(state, payload) {
            state.query = payload;
        },
        setPagination(state, payload) {
            state.pagination = payload;
        }
    },
    actions: {
        list({commit}, query) {
            api.getBannerList(query).then(({data}) => {
                commit('setBannerList', data);
            });
        },
        listNotice({commit}, payload) {
            api.getNoticeList(payload).then(({data}) => {
                commit('setPagination', {
                    page: payload.page,
                    size: payload.size
                });
                commit('setNoticeList', data);
            });
        },
        detail({commit}, id) { // eslint-disable-line
            api.getBannerDetail(id).then(({data}) => {
                commit('setBannerDetail', data);
            });
        },
        detailNotice({commit}, id) { // eslint-disable-line
            api.getNoticeDetail(id).then(({data}) => {
                if (data.title != null) {
                    data.title = data.title ? JSON.parse(data.title) : {},
                        data.content = data.content
                            ? JSON.parse(data.content)
                            : {};
                }
                commit('setNoticeDetail', data);
            });
        },
        create({commit}, banner) { // eslint-disable-line
            return new Promise(resolve => {
                api.createBanner(banner).then(res => {
                    resolve(res);
                });
            });
        },
        createNotice({commit}, banner) { // eslint-disable-line
            return new Promise(resolve => {
                api.createNotice(banner).then(res => {
                    resolve(res);
                });
            });
        },
        update({commit}, {createTime, ...banner}) { // eslint-disable-line
            return new Promise(resolve => {
                api.updateBanner(banner).then(res => {
                    resolve(res);
                });
            });
        },
        updateNotice({commit}, {createTime, ...banner}) { // eslint-disable-line
            return new Promise(resolve => {
                api.updateNotice(banner).then(res => {
                    resolve(res);
                });
            });
        },
        remove({commit}, id) { // eslint-disable-line
            return new Promise(resolve => {
                api.removeBanner(id).then(res => {
                    resolve(res);
                });
            });
        },
        removeNotice({commit}, id) { // eslint-disable-line
            return new Promise(resolve => {
                api.removeNotice(id).then(res => {
                    resolve(res);
                });
            });
        },
        noticeIsShelf({commit}, {id, isShelf}) { // eslint-disable-line
            if (isShelf === 0) {
                isShelf = 1;
            } else {
                isShelf = 0;
            }
            return new Promise(resolve => {
                api.noticeIsShelf(id, isShelf).then(res => {
                    resolve(res);
                });
            });
        },
        updateSort(context, data) {
            return api.updateSort(data);
        }
    }
};

appStore.registerModule('BannerNewSetting', store);
